import { ref, getCurrentInstance } from 'vue';

export const useBusinessCardResolve = () => {
	const { proxy } = getCurrentInstance();
	const businessCardFields = ['businessCard', 'cardInfo', 'cropBusinessCard', 'businessCardId'];

	const businessCardSnapshot = ref({});
	const setBusinessCardSnapshot = data => {
		for (const field of businessCardFields) {
			if (data[field]) {
				proxy.$set(businessCardSnapshot.value, field, data[field]);
			}
		}
	};

	return {
		businessCardFields,
		businessCardSnapshot,
		setBusinessCardSnapshot
	};
};
